import { routes } from './routes';
import angular from 'angular';
import CorePagamentoService from './service';
import { useContext } from '@components';
import CorePagamentosListView from './list';
import { react2angular } from 'react18-react2angular';
export default angular
    .module('app.pagamentos', [])
    .config(routes)
    .service('CorePagamentoService', CorePagamentoService)
    .component('corePagamentoList', react2angular(useContext.use(CorePagamentosListView), [], ['$state', 'UIService', 'CorePagamentoService'])).name;
